import React from 'react';
import GenerationHistory from '../components/GenerationHistory';
export default function Dashboard() { return <GenerationHistory />; }
